import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { flex } from './Flex';

export const flexColumn = css`
  ${flex};
  flex-direction: column;
`;

export const FlexColumn = styled.div`
  ${flexColumn};
`;
